import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { Cookies } from "react-cookie";
import AxiosInstance from "../../components/common/authservice/auth";

import { API_KEY } from "../../environment";

export const amenityList = createAsyncThunk("amenityList", async () => {
  try {
    const cookies = new Cookies();
    const token = cookies.get("token");

    const response = await AxiosInstance.get(`${API_KEY}/api/amenity/get-all`, {
      headers: {
        Authorization: `Barear ${token}`,
      },
      "Content-Type": "application/json",
    });
    return response;
  } catch (error) {
    if (error.response) {
      throw error.response.data.message;
    } else {
      throw error;
    }
  }
});

const initialState = {
  isLoading: false,
  amenityListData: null,
  isError: false,
  errorMessage: "",
};
const amenityListSlice = createSlice({
  name: "amenityList",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(amenityList.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(amenityList.fulfilled, (state, action) => {
      state.isLoading = false;
      state.amenityListData = action.payload;
    });
    builder.addCase(amenityList.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errorMessage = action.error.message;
    });
  },
});

export default amenityListSlice.reducer;
